import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Link from 'components/v2/layout/Link';

const MenuItem = ({ children, href, isSelected = false, className, ...props }) => (
  <Link
    {...props}
    href={href}
    aria-selected={isSelected}
    className={clsx(
      'tw-justify-between',
      'tw-py-4 tw-pl-8 tw-pr-6 xl:tw-bg-white xl:tw-p-0',
      'tw-border-0 tw-border-b tw-border-solid tw-border-gray-100 xl:tw-border-0',
      className,
      {
        'tw-text-black hover:tw-text-purple-500': !isSelected,
        'tw-bg-purple-100 tw-text-purple-500 hover:tw-opacity-80': isSelected,
      }
    )}
  >
    {children}
  </Link>
);

MenuItem.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  isSelected: PropTypes.bool,
  props: PropTypes.object,
};

export default MenuItem;
